import React, { Component } from 'react';
import { Field, FieldArray, reduxForm } from 'redux-form';
import  axios from 'axios';
import validate from './Validations/submitValidationsMembersForm';
import renderField from './RenderField';
import Section from './Section.js'
import {FormattedHTMLMessage} from 'react-intl';
import TopScrolleable from './TopScrolleable.js';
import CustomSpinner from './CustomSpinner';
import Whatsapp from './WhatsappButton.js';
import SaveStepButton from './SaveStepButton';
import withAuthControl from '../auth/Auth.js';

require(`../assets/${process.env.PAGE}/css/components/MembersForm.css`);

const renderMembers = ({ fields, meta: { touched, error, submitFailed } }) => (
  <div>
    <div style={{height:'20px'}}></div>
      {(touched || submitFailed) && error && <CustomAlert bsStyle="danger" message={error}/>}
    <div className='pvc-form'>
      {fields.map((member, index) => (
        <div key={index} >
            {console.log(index)}
              <div className="delete-member-btn" onClick={() => index !== 0 ? fields.remove(index):''}>x</div>
              <h4>{index + 1}° Miembro</h4>
              <Field className="form-control" name={`${member}.name`} autoComplete="off" component={renderField} type="text" label="Nombre y Apellido" />
              <Field className="form-control" name={`${member}.cuil`} autoComplete="off" component={renderField} type="cuil" label="Número de Cuil" />
        <div style={{height:'10px'}}></div>
        </div>
      ))}
    </div>
    <div className="text-center">
        <button
        className="btn pd-simple-button save-step-button btn-add-member"
        onClick={(e) => {
          e.preventDefault();
          fields.push({})
        }}>
        <img className="save-step-icon" src={require(`../assets/${process.env.PAGE}/img/add_members.png`)}/>
        <br></br>Agregar Miembro
        </button>
    </div>
  </div>
);

class MembersForm extends Component {
  constructor(props){
		super(props);
		this.state = {
			factoBusinessAssociation: null,
	  }
  }

  componentDidMount() {
    const ROOT_URL = process.env.API_URL;
    const config = {
        headers:
            {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
    };

    axios.get(`${ROOT_URL}/leads/details`, config).then((response)=> {
        this.setState({
          factoBusinessAssociation: response.data.facto_business_association,
        });
    });
  }

  render() {
    const { handleSubmit, submitting } = this.props;
    const { factoBusinessAssociation } = this.state;

    let title =  factoBusinessAssociation ?
      (<FormattedHTMLMessage id="app.step_members_ss" description="Members info"/>) :
      (<FormattedHTMLMessage id="app.step_members_os" description="Members info"/>);

    return (
      <Section className="intro_form">
        <div className="row">
          <div className="pd-content-left col-md-5 col-lg-5 text-center">
              <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
              {factoBusinessAssociation !== null ? title : ''}
              <div className="show-desktop">
                <Whatsapp phone={this.context.intl.formatMessage({
                              id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                          text={this.context.intl.formatMessage({
                              id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                          value={this.context.intl.formatMessage({
                              id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                          gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                <SaveStepButton/>
              </div>
          </div>
          <div style={{height:'30px'}}></div>
          <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
            <form onSubmit={handleSubmit}>
              {this.props.isLoading &&  <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
              <FieldArray name="members" component={renderMembers} />
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                </div>
              </div>
            </form>
            <div className="show-mobile">
              <Whatsapp phone={this.context.intl.formatMessage({
                            id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                        text={this.context.intl.formatMessage({
                            id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                        value={this.context.intl.formatMessage({
                            id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                        gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
              <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
              <SaveStepButton/>
            </div>
          </div>
        </div>
      </Section>
    );
  }
}

MembersForm.contextTypes = {
        intl: React.PropTypes.object.isRequired
    }

MembersForm = TopScrolleable(MembersForm);

MembersForm = reduxForm({
  form: 'fieldArrays', // a unique identifier for this form
  validate,
  initialValues: {
    "members": [
              {}
               ]
                 }
})(MembersForm);

MembersForm = withAuthControl(MembersForm);

export default MembersForm;


/** WEBPACK FOOTER **
 ** ./src/components/MembersForm.js
 **/